export default class GrilleMixedController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, $translate, MassiaRightsService) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.MassiaRightsService = MassiaRightsService;
		this.index = 0;
	}

	async $onInit() {
		this.canAccessAchatVente = await this.MassiaRightsService.userHasRight('grilletarif', 'read', 'gestion');
		this.canAccessStock = await this.MassiaRightsService.userHasRight('grillestock', 'read', 'gestion');

		if (!this.canAccessAchatVente) this.index = 2;
	}
}
